import React, {Component} from 'react';
import queryString from 'query-string';

import '../../index.css';

// i18n
import {withTranslation} from 'react-i18next';

// Routes
import {withRouter} from 'react-router-dom';

// redux
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

// Components
import {Button} from '@betareader/design-system';

import {fetchNotifications} from '../../modules/notification';

// Analytics
import ux from '../../utils/uxAnalyticsUtil';

const scores = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export class NetPromoterScoreContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.feedbackTextarea = null;
  }

  componentDidMount() {
    const {match, location} = this.props;
    ux.trackPageView(match.path);
    const query = queryString.parse(location.search);
    const {uid, score} = query;
    if (!uid) {
      window.location = 'https://betareader.io';
      return;
    }
    const parsedScore = Number(score);
    this.setState(
      {
        user: uid,
        score: Number.isInteger(parsedScore) && parsedScore >= 1 && parsedScore <= 10
          ? parsedScore : undefined
      },
      () => {
        // auto post the score if it's included in the url
        if (this.state.score) {
          this.postNPS();
        }
      }
    );
  }

  componentWillUnmount() {
    clearTimeout(this.redirectTimeout);
  }

  setScore = event => {
    this.setState(
      {
        score: parseInt(event.currentTarget.dataset.score, 10)
      },
      () => {
        this.postNPS();
      }
    );
  };

  feedbackChanged = event => {
    this.setState({
      feedback: event.target.value
    });
  };

  submitFeedback = () => {
    this.setState(
      {
        done: true
      },
      () => {
        this.postNPS();
        this.redirectTimeout = setTimeout(() => {
          window.location = 'https://app.betareader.io/discover';
        }, 2000);
      }
    );
  };

  postNPS = () => {
    const {user, score, feedback} = this.state;
    fetch(
      `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/nps`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user,
          score,
          feedback
        })
      }
    )
      .then(res => res.json())
      .then(nps => {
        this.setState({
          ...nps
        });
      });
  };

  handleTextAreaRef = ref => {
    if (!this.feedbackTextarea) {
      this.feedbackTextarea = ref;
      this.feedbackTextarea.focus();
    }
  };

  render() {
    const {t} = this.props;
    const {score, feedback, done} = this.state;
    return (
      <main style={{maxWidth: 550, margin: '2rem auto', padding: '1rem', textAlign: 'center'}}>
        <img src='/assets/images/BR-orange-horizontal.png' alt='BetaReader'
          style={{maxWidth: '100%'}} />
        {done ? <h1>{t('Thanks!')}</h1> : (
          <>
            <h1 style={{textAlign: 'left'}}>{t('HowLikelyAreYouToRecommendBetaReaderToAFriend')}</h1>
            <div role='group' aria-label={t('HowLikelyAreYouToRecommendBetaReaderToAFriend')}
              style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(40px, 1fr))', gap: '.5rem'}}>
              {scores.map(value => (
                <Button key={value} data-score={value} variant={score === value ? 'primary' : 'secondary'}
                  aria-pressed={score === value} onClick={this.setScore}>{value}</Button>
              ))}
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', gap: '1rem'}}>
              <span>{t('NotAtAllLikely')}</span><span>{t('ExtremelyLikely')}</span>
            </div>
            {score && (
              <div style={{marginTop: '2rem', textAlign: 'left'}}>
                <label className='br-field' htmlFor='nps-feedback'>
                  <span className='br-field__label'>{t('ThanksDoYouWantToTellUsWhy')}</span>
                  <textarea id='nps-feedback' className='br-field__input' rows={3}
                    value={feedback || ''} onChange={this.feedbackChanged}
                    ref={this.handleTextAreaRef} />
                </label>
                <Button style={{display: 'block', marginLeft: 'auto'}}
                  onClick={this.submitFeedback}>{t('Submit')}</Button>
              </div>
            )}
          </>
        )}
      </main>
    );
  }

}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchNotifications,
      changePage: newPage => push(newPage)
    },
    dispatch
  );

export default withTranslation()(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(NetPromoterScoreContainer)
  )
);
